<template>
<div>
  <section class="content-header">
    <h1>
      用户卡密及课程查询
      <small>快速查询工具</small>
    </h1>
    <ol class="breadcrumb">
      <li><a href="#/"><i class="fa fa-dashboard"></i> Home</a></li>
      <li><a href="#/operateDetails/operateDetails">快速查询工具</a></li>
      <li class="active">用户卡密及课程查询</li>
    </ol>
  </section>

  <section class="content">
    <el-card class="box-card" body-style="padding-bottom:0px">
      <el-form :inline="true">
        <el-form-item>
          <el-input v-model="userName" placeholder="请输入要查询的用户名" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
				</el-form-item>
			</el-form>
    </el-card>

    <el-card class="box-card">
      <el-dialog width="80%" title="历史订单" :visible.sync="dialogTableVisible">
        <el-table :data="orderHiList">
          <el-table-column property="order_id" label="订单号"></el-table-column>
          <el-table-column property="order_date" label="购买时间"></el-table-column>
          <el-table-column property="valid_days" label="有效天数"></el-table-column>
          <el-table-column property="voipNum" label="外教课次数"></el-table-column>
          <el-table-column property="card_number" label="使用卡号"></el-table-column>
          <el-table-column property="card_org" label="充卡orgId"></el-table-column>
        </el-table>
      </el-dialog>
      <div slot="header">
        <span class="header-text">查询结果</span>
        <span style="margin-left:10px;color:red">{{msg}}</span>
        <el-tag v-show="user_name" type="danger" effect="plain">用户名：{{user_name}}</el-tag>
        <el-tag v-show="nick_name" type="success" effect="plain">昵称：{{nick_name}}</el-tag>
      </div>
      <div class="content">
        <el-table
          :data="courseList"
          border
          style="width: 100%">
          <el-table-column prop="package_id" label="课程ID">
            <template slot-scope="scope">
              <el-tooltip content="历史订单" placement="top">
                <el-button type="text" @click="pkgHistory(scope.row)">
                  <el-tag type="danger">{{scope.row.package_id}}</el-tag>
                  &nbsp; 查看历史订单
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="package_name"
            label="课程名">
          </el-table-column>
          <el-table-column
            prop="valid_days"
            label="有效天数">
          </el-table-column>
          <el-table-column
            prop="active_date"
            label="课程开始时间">
          </el-table-column>
          <el-table-column
            prop="exp_date"
            label="课程到期时间">
          </el-table-column>
        </el-table>
        <!-- <span class="note1">注：查询结果仅显示该用户当前有效的课程，已过期课程不显示</span> -->
      </div>
    </el-card>
  </section>
</div>
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full'
import {checkPkg, checkPkgHistory} from 'api/card-course-search'
export default {
  data () {
    return {
      // condition
      userName: '',
      // dialog
      dialogTableVisible: false,
      // errorMsg
      msg: '',
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      // business
      courseList: [],
      user_name: '',
      nick_name: '',
      orderHiList: []
    }
  },
  components: {
    IEcharts
  },
  mounted () {
    this.query()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.page = val
      this.query()
    },
    query () {
      checkPkg({userName: this.userName})
      .then((res) => {
        this.courseList = res.valid_packages // this.parsePkg(res)
        this.user_name = res.user_name
        this.nick_name = res.nick_name
        this.msg = ''
      })
      .catch(msg => {
        this.courseList = []
        this.user_name = ''
        this.nick_name = ''
        this.msg = msg
      })
    },
    parsePkg (res) {
      let arr = []
      res.valid_packages.forEach((t, index) => {
        let obj = {}
        if (index === 0) {
          obj.multiFirst = true
          obj.multiTotal = res.valid_packages.length
        }
        obj.user_name = res.user_name
        obj.nick_name = res.nick_name
        obj.user_id = t.user_id
        obj.package_name = t.package_name
        obj.valid_days = t.valid_days
        obj.active_date = t.active_date
        obj.exp_date = t.exp_date
        obj.package_id = t.package_id
        arr.push(obj)
      })
      return arr
    },
    pkgHistory (row) {
      // alert(row.user_id + '-' + row.package_id)
      checkPkgHistory(row.user_id, row.package_id)
      .then(res => {
        this.orderHiList = res.order_history
        this.dialogTableVisible = true
      })
      .catch(msg => {
        this.$message.error(msg)
      })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) { // :span-method="objectSpanMethod"
      if (columnIndex in [0, 1]) {
        if (row.multiFirst) {
          return {
            rowspan: row.multiTotal,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  }
}
</script>


<style lang="stylus" scoped>
  @import '~common/stylus/base'
    .note1
      color: red
      margin-top: 15px
      float: right
</style>



// WEBPACK FOOTER //
// src/components/card-course-search/course-search.vue